import ExistedBillsList from '@/views/App/CoachBilling/Accountant/Existing/List.vue';
import PendingBillsList from '@/views/App/CoachBilling/Accountant/Pending/List.vue';
import ChatMessageForm from "@/views/App/CoachBilling/Accountant/Pending/MessageForm.vue";
import CoordinatorPendingBillsList from '@/views/App/CoachBilling/Coordinator/PendingBills/List.vue';
import CoordinatorRejectedBillsList from '@/views/App/CoachBilling/Coordinator/RejectedBills/List.vue';
import CoordinatorExistedBillsList from '@/views/App/CoachBilling/Coordinator/ExistingBills/List.vue';
import CoordinatorChatMessageForm from "@/views/App/CoachBilling/Coordinator/RejectedBills/MessageForm.vue";

import CoachingSelection from "@/views/App/CoachBilling/Accountant/Creating/CoachingSelection.vue";
import PrivateCoachingPreviewList from "@/views/App/CoachBilling/Accountant/Creating/PrivateCoaching/PreviewList.vue";
import CaseManagementCoachingPreviewList from "@/views/App/CoachBilling/Accountant/Creating/CaseManagementCoaching/PreviewList.vue";
import GroupCoachingPreviewList from "@/views/App/CoachBilling/Accountant/Creating/GroupCoaching/PreviewList.vue";
import AssistedLivingCoachingPreviewList from "@/views/App/CoachBilling/Accountant/Creating/AssistedLivingCoaching/PreviewList.vue";

const routesCoachBilling = [
    // Creating a bill
    {
        path: 'coaching-selection',
        name: 'coachBillingCoachingSelection',
        component: CoachingSelection
    },
    {
        path: 'private-coaching/preview-list',
        name: 'coachBillingPrivateCoachingPreviewList',
        component: PrivateCoachingPreviewList
    },
    {
        path: 'group-coaching/preview-list',
        name: 'coachBillingGroupCoachingPreviewList',
        component: GroupCoachingPreviewList
    },
    {
        path: 'assisted-living-coaching/preview-list',
        name: 'coachBillingAssistedLivingCoachingPreviewList',
        component: AssistedLivingCoachingPreviewList
    },
    {
        path: 'case-management-coaching/preview-list',
        name: 'coachBillingCaseManagementCoachingPreviewList',
        component: CaseManagementCoachingPreviewList
    },


    // Accountant
    {
        path: 'list',
        name: 'coachBillingExistedBills',
        component: ExistedBillsList
    },
    {
        path: 'pending-bills',
        name: 'coachBillingPendingBills',
        component: PendingBillsList
    },
    {
        path: 'pending-bills/chat/:id',
        name: 'coachBillingPendingBillsChat',
        component: ChatMessageForm,
    },


    // Coordinator
    {
        path: 'coordinator/pending-bills',
        name: 'coachBillingCoordinatorPendingBills',
        component: CoordinatorPendingBillsList
    },
    {
        path: 'coordinator/rejected-bills',
        name: 'coachBillingCoordinatorRejectedBills',
        component: CoordinatorRejectedBillsList
    },
    {
        path: 'coordinator/existing-bills',
        name: 'coachBillingCoordinatorExistingBills',
        component: CoordinatorExistedBillsList
    },
    {
        path: 'coordinator/chat/:id',
        name: 'coachBillingCoordinatorBillChat',
        component: CoordinatorChatMessageForm,
    },
];

export default routesCoachBilling;